/**
 * 底部导航栏组件
 * 移动端底部 2 个主要功能：首页、我的
 * （视频上传入口已移到"我的 / 我的视频"页的"新建视频"按钮）
 */

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './BottomNavigation.css';

const BottomNavigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    if (path === '/profile') {
      const curTab = new URLSearchParams(location.search).get('tab') || 'management';
      if (location.pathname === '/profile' && curTab === 'management') return;
      navigate('/profile?tab=management');
      return;
    }
    if (location.pathname === path) return;
    navigate(path);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="bottom-navigation">
      
      <div className="bottom-nav-item" onClick={() => handleNavigate('/')}>
        <div className={`nav-icon ${isActive('/') ? 'active' : ''}`}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </div>
        <span className={`nav-label ${isActive('/') ? 'active' : ''}`}>首页</span>
      </div>

      <div className="bottom-nav-item" onClick={() => handleNavigate('/profile')}>
        <div className={`nav-icon ${isActive('/profile') ? 'active' : ''}`}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </div>
        <span className={`nav-label ${isActive('/profile') ? 'active' : ''}`}>我的</span>
      </div>
    </div>
  );
};

export default BottomNavigation;

